import { Link } from "react-router-dom";
import { base_url } from "../../../constants";

export default function Iconos_izquierda(){
    return(
        <div className="d-none d-md-block col-md-3 text-start py-3">
            <Link to={`/${base_url}/`} className="mx-2"><i className="fas fa-home fa-lg"></i></Link>
            <a href="mailto:contactoweb@te.gob.mx?Subject=Contacto%20Editotial" aria-label="Correo editorial"  title="se abrirá aplicación de correo">
                <i className="fas fa-envelope fa-lg"></i><span className="sr-only">Escribir correo a contactoweb@te.gob.mx</span>
            </a>
        </div>
    )
}